import { render, staticRenderFns } from "./weekdays_checkbox_addon.vue?vue&type=template&id=4af3e798&scoped=true"
import script from "./weekdays_checkbox_addon.vue?vue&type=script&lang=js"
export * from "./weekdays_checkbox_addon.vue?vue&type=script&lang=js"
import style0 from "./weekdays_checkbox_addon.vue?vue&type=style&index=0&id=4af3e798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af3e798",
  null
  
)

export default component.exports